// time format = hh:mm:ss
export const getTimeInSeconds = (time: string) => {
    if (time) {
        const [hours, minutes, seconds] = time.split(":");
        return Number(hours) * 3600 + Number(minutes) * 60 + Number(seconds);
    }
    return 0;
};

export const getSecondsInTime = (seconds: number) => {
    if (seconds) {
        return new Date(seconds * 1000).toISOString().substring(11, 19);
    }
    return "00:00:00";
};

export function formatTimeHHMM(date: Date | string): string {
    return new Date(date).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "UTC",
    });
}

// 2025-08-10T10:39:11.59 -> 10/08/2025

export function formatDate(date: Date | string): string {
    return new Date(date).toLocaleDateString("en-GB");
}
